/**
 * Label for a header counter badge (notifications, cart).
 * Returns null when there is nothing to show so the badge is not rendered
 * at all — an empty "0" bubble is visual noise, not information.
 */
export const NAVBAR_BADGE_MAX = 99

export const formatNavbarBadge = (count: unknown, max: number = NAVBAR_BADGE_MAX): string | null => {
  const n = typeof count === 'number' ? count : Number(count)
  if (!Number.isFinite(n) || n <= 0) return null
  const whole = Math.floor(n)
  return whole > max ? `${max}+` : String(whole)
}
